module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "body"
    }
  }, [_c('app-header', {
    attrs: {
      "issessionset": _vm.sessionSet,
      "user": _vm.user,
      "cart": _vm.cart,
      "items": _vm.items
    },
    on: {
      "logout": _vm.logout
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "sidebar",
      "issessionset": _vm.sessionSet
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    attrs: {
      "issessionset": _vm.sessionSet,
      "items": _vm.items,
      "user": _vm.user,
      "alreadyAdded": _vm.alreadyAdded
    },
    on: {
      "session": function($event) {
        _vm.dadCheck($event)
      },
      "addtocart": function($event) {
        _vm.add($event)
      },
      "removeitem": function($event) {
        _vm.removeitem($event)
      },
      "endtransaction": _vm.endtransaction
    }
  })], 1), _vm._v(" "), (_vm.routeEnabled) ? _c('app-footer', {
    attrs: {
      "issessionset": _vm.sessionSet
    }
  }) : _vm._e(), _vm._v(" "), (_vm.routeEnabled) ? _c('app-copyright') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-524349f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 153
// module chunks = 0